/**
 * White-label hook: hide the Emergent platform badge on customer-facing public pages
 * (checkout, success, cancel, public storefront). Keeps it visible on admin pages.
 * The badge is hardcoded in /public/index.html — we hide it via CSS injection.
 */
import { useEffect } from 'react';

export function useHideEmergentBadge() {
  useEffect(() => {
    // Belt-and-suspenders: ensure PostHog session recording is OFF on these
    // customer-facing pages. rrweb recording the Stripe payment iframes on
    // iOS/WebKit blows the memory limit and triggers an endless Safari reload
    // loop. The init in index.html already disables it on /checkout, but stop
    // here too in case recording was started before this mounts.
    try { window.posthog?.stopSessionRecording?.(); } catch { /* noop */ }
    // Idempotent: only inject once
    const STYLE_ID = '__hide_emergent_badge__';
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #emergent-badge,
      a[href*="emergent.sh"][id="emergent-badge"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);
    // Hide if already present
    const existing = document.getElementById('emergent-badge');
    if (existing) existing.style.display = 'none';
    return () => {
      // On unmount (e.g. navigating to admin), restore the badge.
      const el = document.getElementById(STYLE_ID);
      if (el) el.remove();
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.style.display = '';
    };
  }, []);
}
